import { render, staticRenderFns } from "./CardFormaPago.vue?vue&type=template&id=127344c3&"
import script from "./CardFormaPago.vue?vue&type=script&lang=js&"
export * from "./CardFormaPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports